<div class="container" *ngIf="product?.images?.imagesUrl?.length">
    <div class="inner-content">
        <img class="product-image" [src]="product.images.imagesUrl[0]" />
        <div class="icon-text">
            <mat-icon class="done-icon">check</mat-icon>
            <span class="review-text">{{ "userReviewPage.label.reviewSubmitted" | translate }}</span>
        </div>
        <div class="review-wish-text-container">
            <span class="review-wish-text">{{ "userReviewPage.label.wish" | translate }}</span>
        </div>

        <div class="button-container">
            <button mat-flat-button (click)="navigateReviewListPage()" class="btn-primary-gradient">
                {{ "userReviewPage.button.continue" | translate }}
            </button>
        </div>
    </div>
</div>
